import * as React from 'react';
import '../../../productAccessPanel/ProductAccessPanel.css';
import { AppStore } from '../../../../../stores';
import { inject, observer } from 'mobx-react';
import ProductService from '../../../../../services/ProductService';
import { FilePicker } from '../../../../../mindjuiceApp/UI/filePicker/FilePicker';
import AdminService from '../../../../../services/AdminService';
import DocumentPicker from '../../../../../mindjuiceApp/UI/documentPicker/DocumentPicker';
import AdminModuleDocument from '../../../../../mindjuiceApp/UI/adminModuleDocument/AdminModuleDocument';
import { IModuleDocument } from '../../../../../interfaces/IModuleDocument';
import MindPaperEditPanel from '../../../productEditPanel/mindPaperEditPanel/MindPaperEditPanel';
import { IAPivot } from '../../../../../mindjuiceApp/UI/pivot/Pivot';
import { Pivot } from '../../../../../mindjuiceApp/pivot/Pivot';

export interface IProps {
  teamId: string;
  selectedLanguage;
  appStore?: AppStore;
}

export interface IState {
  availablemindPapers: any[];
  selectedWorkbookType: string;
  selectedLanguage;
}

@inject('appStore')
@observer
export default class TeamModuleEditPanel extends React.Component<IProps, IState> {

  constructor(props) {
    super(props);
    this.state = {
      availablemindPapers: [],
      selectedWorkbookType: "mindPaper",
      selectedLanguage: props.selectedLanguage ?? "danish"
    }
  }

  public componentWillReceiveProps(props: IProps): void {
    if (props.teamId !== undefined && props.teamId !== this.props.teamId) {
      this.getMindPapers();
    }
    if (props.selectedLanguage !== this.props.selectedLanguage) {
      this.setState({
        selectedLanguage: props.selectedLanguage ?? this.state.selectedLanguage
      });
    }
  }

  private getMindPapers(selectedObjectId?: string): void {
    ProductService.getMindPapers().then((mindPapers: any[]) => {
      if (this.props.appStore) {
        this.props.appStore!.mindPapers = mindPapers;
        if (selectedObjectId && this.props.appStore!.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
          this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].mindPaperId = selectedObjectId;
        }
      }
      this.loadMindPapers();
    });
  }

  private loadMindPapers(): void {
    const availablemindPapers: JSX.Element[] = [];
    availablemindPapers.push(
      <option value="all">Vælg MindPaper</option>
    );
    this.setState({ availablemindPapers });
    if (this.props.appStore?.mindPapers) {
      this.props.appStore!.mindPapers.forEach((mindPaper: any) => {
        if (this.props.appStore?.teamModuleIndexToEdit !== undefined && this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit]?.mindPaperId === mindPaper.objectId) {
          availablemindPapers.push(
            <option value={mindPaper.objectId} selected>{mindPaper.title}</option>
          );
        } else {
          availablemindPapers.push(
            <option value={mindPaper.objectId}>{mindPaper.title}</option>
          );
        }
      });
      this.setState({ availablemindPapers });
      this.forceUpdate();
    }
  }

  private array_move(arr, old_index, new_index): any[] {
    if (new_index >= arr.length) {
      var k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  render() {
    const documents: JSX.Element[] = [];
    const module = this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1];
    if (module?.documents && module.documents.length > 0) {
      module.documents.forEach((documentId: string, index) => {
        documents.push(
          <AdminModuleDocument
            id={documentId}
            isMobile={this.props.appStore?.isMobile || false}
            disableMoveDown={(module.documents?.length ?? 0) - 1 === index}
            disableMoveUp={index === 0}
            selectedLanguage={this.state.selectedLanguage}
            onDelete={() => {
              if (module?.documents) {
                module.documents.splice(index, 1);
              }
            }}
            onMoveUp={() => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]?.documents && module?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].documents = this.array_move(module.documents, index, index - 1);
              }
            }}
            onMoveDown={() => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]?.documents && module?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].documents = this.array_move(module.documents, index, index + 1);
              }
            }}
            onUpdate={(document: any) => {
              if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]?.documents) {
                this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].documents![index] = document;
              }
            }}
          />
        );
      });
    }
    return (
      <div>
        <div
          className="productModuleEditPanelWrapper"
          style={{
            visibility: this.props.appStore?.teamModuleIndexToEdit !== undefined ? "visible" : "hidden"
          }}
          onClick={() => {
            if (this.props.appStore) {
              (this.props.appStore as any).teamModuleIndexToEdit = undefined;
              this.props.appStore!.isAddingModule = false;
            }
          }}
        />
        <div
          className="productModuleEditPanel"
          style={{
            right: this.props.appStore?.teamModuleIndexToEdit !== undefined ? 0 : -620
          }}
        >
          <Pivot
            highlightColor="#b362fa"
            textColor="#333333"
            items={[
              {
                key: "danish",
                text: window.loc?.strings?.Danish || "Danish",
              },
              {
                key: "english",
                text: window.loc?.strings?.English || "English",
              }
            ]}
            style={{
              fontSize: "14px",
              textTransform: "uppercase",
              width: "100%"
            }}
            selectedKey={this.state.selectedLanguage}
            select={(selectedLanguage: string) => {
              this.setState({ selectedLanguage });
            }}
          />
          {this.props.appStore?.teamModuleIndexToEdit !== undefined && module &&
            <div>
              <h3 style={{ width: "fit-content" }}>Modul titel</h3>
              <img width="20" height="20" style={{ marginTop: 20, marginLeft: 5 }} src="https://img.icons8.com/ios-glyphs/30/google-translate.png" alt="google-translate" />
              <input
                type="text"
                value={this.state.selectedLanguage === "danish" ? module?.title || "" : module?.localizedTitle?.[this.state.selectedLanguage] || module?.title || ""}
                onChange={(event: any) => {
                  if (this.state.selectedLanguage === "danish" && this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                    this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].title = event.target.value;
                  } else if (module) {
                    if (!module.localizedTitle) {
                      module.localizedTitle = {};
                    }
                    module.localizedTitle[this.state.selectedLanguage] = event.target.value;
                  }
                }}
              />
              <h3>Medie</h3>
              <div className="inputFieldLabel" style={{ width: "fit-content" }}>Medie URL (Vimeo eller MP3)</div>
              <img width="20" height="20" style={{ marginLeft: 5 }} src="https://img.icons8.com/ios-glyphs/30/google-translate.png" alt="google-translate" />
              <FilePicker
                url={this.state.selectedLanguage === "danish" ? module?.videoUrl || "" : module?.localizedVideoUrl?.[this.state.selectedLanguage] || module?.videoUrl || ""}
                placeholderText={"Indsæt et link eller upload en mp3-fil..."}
                inputWidth={this.props.appStore?.isMobile ? "81%" : "87%"}
                onChange={(url: string) => {
                  if (this.state.selectedLanguage === "danish" && this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                    this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].videoUrl = url;
                  } else if (module) {
                    if (!module.localizedVideoUrl) {
                      module.localizedVideoUrl = {};
                    }
                    module.localizedVideoUrl[this.state.selectedLanguage] = url;
                  }
                  if (url && url != undefined && url !== "" && url.indexOf("mindjuice.herokuapp.com/parse/files") !== -1) {
                    const splittedUrl = url.split(".");
                    let fileType = splittedUrl[splittedUrl.length - 1];
                    AdminService.addFile({
                      url: url,
                      fileType: fileType,
                      product: this.props.appStore?.teamToEdit?.productId,
                      team: this.props.appStore?.teamToEdit?.team,
                      type: "teamModuleMedia"
                    });
                  }
                }}
              />
              <div className="inputFieldLabel">MP3 coverbillede</div>
              <img width="20" height="20" style={{ marginLeft: 5 }} src="https://img.icons8.com/ios-glyphs/30/google-translate.png" alt="google-translate" />
              <FilePicker
                url={this.state.selectedLanguage === "danish" ? module?.coverImage || "" : module?.localizedCoverImage?.[this.state.selectedLanguage] || module?.coverImage || ""}
                placeholderText={"Indsæt et link eller upload en billedfil..."}
                inputWidth={this.props.appStore?.isMobile ? "81%" : "87%"}
                onChange={(url: string) => {
                  if (this.state.selectedLanguage === "danish" && this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                    this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].coverImage = url;
                  } else if (module) {
                    if (!module.localizedCoverImage) {
                      module.localizedCoverImage = {};
                    }
                    module.localizedCoverImage[this.state.selectedLanguage] = url;
                  }
                  if (url && url != undefined && url !== "" && url.indexOf("mindjuice.herokuapp.com/parse/files") !== -1) {
                    const splittedUrl = url.split(".");
                    let fileType = splittedUrl[splittedUrl.length - 1];
                    AdminService.addFile({
                      url: url,
                      fileType: fileType,
                      product: this.props.appStore?.teamToEdit?.productId,
                      team: this.props.appStore?.teamToEdit?.team,
                      type: "teamModuleImage"
                    });
                  }
                }}
              />
              <h3>Workbook</h3>
              <IAPivot
                highlightColor={"#ffffff"}
                items={[
                  {
                    key: 'mindPaper',
                    text: "MindPaper"
                  },
                  {
                    key: 'file',
                    text: "Fil"
                  }
                ]}
                asTabs
                tabBackgrondColor="gray"
                selectedTabBackgrondColor="#7a12d4"
                selectedKey={this.state.selectedWorkbookType}
                select={(selectedTab: string) => {
                  this.setState({ selectedWorkbookType: selectedTab });
                }}
                style={{
                  width: this.props.appStore?.isMobile ? "100%" : "50%",
                  marginTop: 0,
                  height: 30,
                  marginBottom: 10,
                  textAlign: "center",
                  position: "relative",
                  float: "left"
                }}
                isMobile={this.props.appStore?.isMobile || false}
              />
              {this.state.selectedWorkbookType === "mindPaper" ?
                <>
                  <select
                    name="cars"
                    id="cars"
                    placeholder="Vælg et MindPaper"
                    value={module?.mindPaperId || ""}
                    onChange={(selectedOption: any) => {
                      if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                        this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].mindPaperId = selectedOption.target.value;
                        this.forceUpdate();
                      }
                    }}
                    style={{
                      width: "calc(100% - 240px)",
                      clear: "both"
                    }}
                  >
                    {this.state.availablemindPapers}
                  </select>
                  <button
                    onClick={() => {
                      if (this.props.appStore) {
                        this.props.appStore!.mindPaperToEdit = {};
                      }
                    }}
                    style={{
                      marginLeft: 20,
                      marginRight: 0,
                      width: 100,
                      float: "left"
                    }}
                  >
                    Tilføj nyt MindPaper
                  </button>
                  <button
                    disabled={!module?.mindPaperId}
                    onClick={() => {
                      if (module?.mindPaperId) {
                        ProductService.getMindPaper(module.mindPaperId).then((mindPaperToEdit) => {
                          if (this.props.appStore) {
                            this.props.appStore!.mindPaperToEdit = mindPaperToEdit;
                          }
                        })
                      }
                    }}
                    style={{
                      marginLeft: 20,
                      marginRight: 0,
                      width: 100,
                      float: "left"
                    }}
                  >
                    Rediger valgt Mindpaper
                  </button>
                </>
                :
                <div style={{
                  clear: "both",
                  float: "left",
                  width: "100%"
                }}>
                  <div className="inputFieldLabel">Fil</div>
                  <FilePicker
                    url={module?.workbook || ""}
                    placeholderText={"Indsæt et link eller upload en fil..."}
                    inputWidth={this.props.appStore?.isMobile ? "81%" : "87%"}
                    onChange={(url: string) => {
                      if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                        this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].workbook = url;
                        if (url && url != undefined && url !== "" && url.indexOf("mindjuice.herokuapp.com/parse/files") !== -1) {
                          const splittedUrl = url.split(".");
                          let fileType = splittedUrl[splittedUrl.length - 1];
                          AdminService.addFile({
                            url: url,
                            fileType: fileType,
                            product: this.props.appStore?.teamToEdit?.productId,
                            team: this.props.appStore?.teamToEdit?.team,
                            type: "teamModuleFile"
                          });
                        }
                      }
                    }}
                  />
                  <div
                    className="inputFieldLabel"
                    style={{
                      clear: "both"
                    }}
                  >
                    Link tekst
                  </div>
                  <input
                    type="text"
                    value={module?.workbookText || ""}
                    onChange={(event: any) => {
                      if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                        this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].workbookText = event.target.value;
                      }
                    }}
                  />
                  <div
                    className="flowpaper"
                    style={{
                      clear: "both"
                    }}
                  >
                    <input
                      type="checkbox"
                      checked={module?.openInSameWindow || false}
                      onChange={() => {
                        if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                          const currentModule = this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!];
                          currentModule.openInSameWindow = currentModule.openInSameWindow !== undefined ? !currentModule.openInSameWindow : true;
                        }
                      }}
                      style={{
                        width: 20,
                        marginTop: -2
                      }}
                    />
                    Åben i samme fane
                  </div>
                </div>
              }
              <h3>Dokumenter</h3>
              <IAPivot
                highlightColor={"#ffffff"}
                items={[
                  {
                    key: 'info',
                    text: "Information"
                  },
                  {
                    key: 'content',
                    text: "Indhold"
                  },
                  {
                    key: 'exam',
                    text: "Eksamen"
                  }
                ]}
                asTabs
                autoTabWidth
                tabBackgrondColor="gray"
                selectedTabBackgrondColor="#7a12d4"
                selectedKey={module?.moduleType ?? "content"}
                select={(moduleType: string) => {
                  if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1] && (moduleType === "content" || moduleType === "exam" || moduleType === "info")) {
                    this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!].moduleType = moduleType as "content" | "exam" | "info";
                  }
                }}
                style={{
                  width: this.props.appStore?.isMobile ? "100%" : "50%",
                  marginTop: 0,
                  height: 30,
                  marginBottom: 10,
                  textAlign: "center",
                  position: "relative",
                  float: "left"
                }}
                isMobile={this.props.appStore?.isMobile || false}
              />
              {documents}
              <DocumentPicker
                document={{
                  product: this.props.appStore?.teamToEdit?.productId,
                  team: this.props.appStore?.teamToEdit?.team,
                  type: "teamModuleDocument"
                }}
                selectedLanguage={this.state.selectedLanguage}
                isMobile={this.props.appStore?.isMobile || false}
                onChange={(document: IModuleDocument) => {
                  if (this.props.appStore?.teamToEdit?.modules?.[this.props.appStore!.teamModuleIndexToEdit ?? -1]) {
                    const currentModule = this.props.appStore!.teamToEdit.modules[this.props.appStore!.teamModuleIndexToEdit!];
                    if (!currentModule.documents) {
                      currentModule.documents = [];
                    }
                    currentModule.documents.push(document.objectId);
                  }
                }}
              />
              {/* Save */}
              <button
                style={{
                  clear: "both"
                }}
                onClick={() => {
                  if (this.props.appStore?.teamToEdit && this.props.appStore!.teamToEdit.objectId !== undefined) {
                    ProductService.updateProduct(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        (this.props.appStore as any).teamModuleIndexToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  } else if (this.props.appStore?.teamToEdit) {
                    ProductService.createProduct(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        (this.props.appStore as any).teamModuleIndexToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  }
                }}
              >
                {this.props.appStore?.isAddingModule ? "Opret" : "Opdater"}
              </button>

              {/* Save and notify */}
              <button
                onClick={() => {
                  if (this.props.appStore?.teamToEdit && this.props.appStore!.teamToEdit.objectId !== undefined) {
                    ProductService.updateTeam(this.props.appStore!.teamToEdit).then(() => {
                      if (this.props.appStore) {
                        this.props.appStore!.notificationToEdit = {
                          objectId: "new",
                          sendToAll: false,
                          title: `${window.loc?.strings?.thereIsNewContentFor || 'There is new content for'} ${this.props.appStore!.selectedProduct?.title || ''}`,
                          text: `${window.loc?.strings?.thereIsNewContentFor || 'There is new content for'} ${module?.title || ''}`,
                          linkText: window.loc?.strings?.open || 'Open',
                          link: location.href,
                          receivers: [{
                            product: this.props.appStore!.selectedProduct,
                            selected: false,
                            teams: [{ team: this.props.appStore!.teamToEdit, selected: true }]
                          }]
                        };
                        (this.props.appStore as any).teamModuleIndexToEdit = undefined;
                        this.props.appStore!.isAddingModule = false;
                      }
                    });
                  }
                }}
              >
                {this.props.appStore?.isAddingModule ? "Opret og send besked til deltagere" : "Opdater og send besked til deltagere"}
              </button>

              <button
                style={{
                  marginLeft: 10
                }}
                onClick={() => {
                  if (this.props.appStore) {
                    if (this.props.appStore!.isAddingModule && this.props.appStore!.teamToEdit?.modules && this.props.appStore!.teamModuleIndexToEdit !== undefined) {
                      this.props.appStore!.teamToEdit.modules.splice(this.props.appStore!.teamModuleIndexToEdit, 1);
                    }
                    (this.props.appStore as any).teamModuleIndexToEdit = undefined;
                    this.props.appStore!.isAddingModule = false;
                  }
                }}
              >
                Annuller
              </button>
              <button
                onClick={() => {
                  if (this.props.appStore?.teamToEdit?.modules && this.props.appStore!.teamModuleIndexToEdit !== undefined) {
                    this.props.appStore!.teamToEdit.modules.splice(this.props.appStore!.teamModuleIndexToEdit, 1);
                    (this.props.appStore as any).teamModuleIndexToEdit = undefined;
                    this.props.appStore!.isAddingModule = false;
                  }
                }}
                style={{
                  backgroundColor: "gray",
                  marginLeft: 10
                }}
              >
                Slet
              </button>
            </div>
          }
        </div>
        {this.props.appStore?.teamToEdit && this.props.appStore?.mindPaperToEdit && !this.props.appStore!.mindPaperToEdit.document &&
          <MindPaperEditPanel
            reloadMindPapers={(selectedId: string) => {
              if (this.props.appStore) {
                (this.props.appStore as any).mindPaperToEdit = undefined;
                this.getMindPapers(selectedId);
              }
            }}
          />
        }
      </div>
    );
  }
}